var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobileBroadbandAndTv = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Smart-Tv-Phone-Control-Play--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Smart Tv Phone Control Play Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.92 16.38v-1.5a0.22 0.22 0 0 1 0.06 -0.14v-3.05H2a0.37 0.37 0 0 1 -0.37 -0.38V1.93A0.37 0.37 0 0 1 2 1.55h14.31a0.38 0.38 0 0 1 0.37 0.38v0.52h1.5V1.18A1.13 1.13 0 0 0 17.06 0.05H1.29A1.14 1.14 0 0 0 0.16 1.18v12.38a1.13 1.13 0 0 0 1.13 1.13h6.94a0.18 0.18 0 0 1 0.19 0.19v1.5a0.19 0.19 0 0 1 -0.19 0.19H5.79a0.75 0.75 0 1 0 0 1.5H10v-1.55a0.25 0.25 0 0 1 -0.08 -0.14Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.83 21.15V6.75A2.8 2.8 0 0 0 21 4h-6.72a2.81 2.81 0 0 0 -2.8 2.8v14.4a2.81 2.81 0 0 0 2.8 2.8H21a2.8 2.8 0 0 0 2.83 -2.85ZM13.48 6.75a0.8 0.8 0 0 1 0.8 -0.8H21a0.8 0.8 0 0 1 0.8 0.8v12.93h-8.32Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.79 15.09a0.53 0.53 0 0 0 0.24 0.45 0.54 0.54 0 0 0 0.51 0.05l4.62 -2.38a0.64 0.64 0 0 0 0.37 -0.58 0.63 0.63 0 0 0 -0.37 -0.57l-4.62 -2.38a0.52 0.52 0 0 0 -0.51 0 0.54 0.54 0 0 0 -0.24 0.45Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobileBroadbandAndTv);
export default ForwardRef;